import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from "react";
import { Input, DatePicker, Button, Select, message } from "antd";
import Menubar from "../../../components/WhrManager/App";
import { http } from "../../../services/http";
import { SearchOutlined } from "@ant-design/icons";
import debounce from "lodash.debounce";
import Highlighter from "react-highlight-words";
import { useTranslation } from "react-i18next";
import RowDataShipmentModal from "../../../components/WhrManager/row-data-shipment";
import moment from "moment";
import RemoveItemModal from "../../../components/WhrManager/removeModal";
import HeaderWithInfinityScroll from "../../../components/HeaderWithInfinityScroll";
import EmployeesModal from "../../../components/WhrManager/Employees";
import { get } from "lodash";

const { RangePicker } = DatePicker;

const Shipments = () => {
  const { t } = useTranslation();
  const isLoadingRef = useRef(false);

  const [fdata, setFData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMoreData, setHasMoreData] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isRemove, setRemove] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [data, setData] = useState([]);
  const [docNum, setDocNum] = useState("");
  const [cardName, setCardName] = useState("");
  const [slpName, setSlpName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [orderStatus, setOrderStatus] = useState("");
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [total, setTotal] = useState(0);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [docStatus, setDocStatus] = useState("");
  const [isEmployeeModalVisible, setIsEmployeeModalVisible] = useState(false);

  const orderStatusLabels = [
    { label: "Barchasi", value: "" },
    { label: "Tasdiqlandi", value: "Tasdiqlandi" },
    { label: "Mas'ulga biriktirildi", value: "Biriktirildi" },
    { label: "Buyurtma yuklandi", value: "BuyurtmaYuklandi" },
    { label: "Yuklash tasdiqlandi", value: "YuklashTasdiqlandi" },
  ];

  const datas = [];

  const fetchData = useCallback(
    async (
      page,
      ScardName,
      SdocNum,
      SslpName,
      SstartDate,
      SendDate,
      status,
      docStatus,
      isLoadMore = false,
    ) => {
      if (isLoadingRef.current) return;

      try {
        isLoadingRef.current = true;
        if (!isLoadMore) {
          setLoading(true);
        } else {
          setIsLoadingMore(true);
        }

        let url = "";
        setLoading(true);

        url = `api/yuklanganbuyurtmalar?orderStatus=${status}&cardName=${ScardName}&docNum=${SdocNum}&startDate=${SstartDate}&endDate=${SendDate}&pageToken=${page}&docStatus=${docStatus}`;

        const { data } = await http.get(url);

        const formattedData = data.docs;
        const hasMore = formattedData.length === 20 ? true : false;
        setHasMoreData(hasMore);
        setTotal(get(data, "total", 0));
        if (page === 1) {
          setFData(formattedData);
        } else {
          setFData((prevData) => {
            const newData = formattedData.filter(
              (item) => !prevData.some((p) => p.docNum === item.docNum),
            );
            return [...prevData, ...newData];
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
        setIsLoadingMore(false);
        isLoadingRef.current = false;
      }
    },
    [cardName, docNum, startDate, endDate, slpName, orderStatus, docStatus],
  );

  useEffect(() => {
    fetchData(
      currentPage,
      cardName,
      docNum,
      slpName,
      startDate,
      endDate,
      orderStatus,
      docStatus,
      currentPage > 1,
    );
  }, [
    fetchData,
    currentPage,
    cardName,
    docNum,
    slpName,
    startDate,
    endDate,
    docStatus,
    orderStatus,
  ]);

  useEffect(() => {
    fetchResponsibleManagers();
  }, []);

  const fetchResponsibleManagers = async () => {
    try {
      const { data } = await http.get(
        `api/sales/warehouse-employee-info?skip=0`,
      );

      setData(data.data);
    } catch (err) {
      console.log(err);
    }
  };

  const handleNextPage = () => {
    if (hasMoreData) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  const handleRowClick = (record) => {
    setSelectedRowData(record);
    setIsModalVisible(true);
  };

  let searchInput = null;

  const handleDateRangeChange = (dates, confirm, dataIndex) => {
    debouncedSearch(dates, dataIndex, confirm);
  };

  const handleStartDate = (e) => {
    setCurrentPage(1);
    setFData([]);
    setStartDate(e.target.value);
  };

  const handleEndDate = (e) => {
    setCurrentPage(1);
    setFData([]);

    setEndDate(e.target.value);
  };

  const debouncedSearch = useMemo(
    () =>
      debounce((value, dataIndex, confirm) => {
        if (dataIndex === "mijoz") {
          if (value) {
            setCurrentPage(1);
            setFData([]);

            setCardName(value);
          } else {
            setCurrentPage(1);
            setFData([]);

            setCardName("");
          }
        } else if (dataIndex === "u_OrderStatus") {
          if (value) {
            setCurrentPage(1);
            setFData([]);
            setOrderStatus(value);
          } else {
            setCurrentPage(1);
            setFData([]);
            setOrderStatus("");
          }
        } else if (dataIndex === "docStatus") {
          if (value) {
            setCurrentPage(1);
            setFData([]);
            setDocStatus(value);
          } else {
            setCurrentPage(1);
            setFData([]);
            setDocStatus("");
          }
        } else if (dataIndex === "docNum") {
          if (value) {
            setCurrentPage(1);
            setFData([]);

            setDocNum(value);
          } else {
            setCurrentPage(1);
            setFData([]);

            setDocNum("");
          }
        } else if (dataIndex === "yaratdi") {
          if (value) {
            setCurrentPage(1);
            setFData([]);

            setSlpName(value.toUpperCase());
          } else {
            setCurrentPage(1);
            setFData([]);

            setSlpName("");
          }
        } else if (dataIndex === "sana") {
          if (value) {
            const formattedStartDate = new Date(value[0]).toLocaleString();
            const formattedEndDate = new Date(value[1]).toLocaleString();

            if (formattedStartDate && formattedEndDate) {
              setCurrentPage(1);
              setFData([]);

              setStartDate(moment(formattedStartDate).format("YYYY-MM-DD"));
              setEndDate(moment(formattedEndDate).format("YYYY-MM-DD"));
            }
          } else {
            setCurrentPage(1);
            setFData([]);

            setStartDate("");
            setEndDate("");
          }
        } else {
        }
        confirm();
      }, 3000),
    [fetchData, currentPage],
  );

  const handleButtonClick = (e, record) => {
    e.stopPropagation();
    setRemove(true);
    setSelectedRowData(record);
  };

  const getColumnSearchProps = (dataIndex) => {
    if (dataIndex === "sana") {
      return {
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
          <div style={{ padding: 8 }}>
            <RangePicker
              value={selectedKeys && selectedKeys[0] ? selectedKeys : []}
              onChange={(dates) => {
                setSelectedKeys(dates ? dates : []);
                handleDateRangeChange(dates, confirm, dataIndex);
              }}
              style={{ marginBottom: 8, display: "block" }}
              disabledDate={(current) =>
                current && current > moment().endOf("day")
              }
            />
          </div>
        ),
        filterIcon: (filtered) => (
          <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
        ),
        onFilter: (value, record) => {
          if (Array.isArray(value) && value.length === 2) {
            const [startDate, endDate] = value;
            const recordDate = moment(record[dataIndex]);
            return recordDate.isBetween(startDate, endDate, "[]");
          }
          return true;
        },
        render: (text) => text,
      };
    }

    if (dataIndex === "u_OrderStatus") {
      return {
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
          <div style={{ padding: 8 }}>
            <Select
              value={selectedKeys[0] || ""}
              onChange={(value) => {
                setSelectedKeys(value ? [value] : [""]);
                debouncedSearch(value, dataIndex, confirm);
              }}
              style={{ width: 188, marginBottom: 8, display: "block" }}
              options={orderStatusLabels.map((item) => {
                return {
                  value: item.value,
                  label: item.label,
                };
              })}
            />
          </div>
        ),
        filterIcon: (filtered) => (
          <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
        ),
        onFilter: (value, record) => {
          if (value === "") {
            return true;
          }
          return record[dataIndex]
            ? record[dataIndex].toString().toLowerCase() === value.toLowerCase()
            : "";
        },
        render: (text) => text,
      };
    }
    if (dataIndex === "docStatus") {
      return {
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
          <div style={{ padding: 8 }}>
            <Select
              value={selectedKeys[0] || ""}
              onChange={(value) => {
                setSelectedKeys(value ? [value] : [""]);
                debouncedSearch(value, dataIndex, confirm);
              }}
              style={{ width: 188, marginBottom: 8, display: "block" }}
              options={[
                {
                  value: "",
                  label: t("all"),
                },
                {
                  value: "O",
                  label: t("open"),
                },
                {
                  value: "C",
                  label: t("closed"),
                },
              ]}
            />
          </div>
        ),
        filterIcon: (filtered) => (
          <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
        ),
        onFilter: (value, record) => {
          if (value === "") {
            return true;
          }
          return record[dataIndex]
            ? record[dataIndex].toString().toLowerCase() === value.toLowerCase()
            : "";
        },
        render: (text) => text,
      };
    }

    return {
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
        <div style={{ padding: 8 }}>
          <Input
            ref={(node) => {
              searchInput = node;
            }}
            placeholder={`${t("search")} ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              handleSearch(e, confirm, dataIndex);
            }}
            style={{ width: 188, marginBottom: 8, display: "block" }}
          />
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      onFilter: (value, record) =>
        record[dataIndex]
          ? record[dataIndex]
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase())
          : "",
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTimeout(() => searchInput.select(), 100);
        }
      },
      render: (text) =>
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ""}
          />
        ) : (
          text
        ),
    };
  };

  const handleSearch = (e, confirm, dataIndex) => {
    const value = e.target.value;
    debouncedSearch(value, dataIndex, confirm);
  };

  const columns = [
    {
      title: t("mijoz"),
      dataIndex: "cardName",
      key: "cardName",
      ...getColumnSearchProps("mijoz"),
    },
    {
      title: t("numZakaz"),
      dataIndex: "docNum",
      key: "docNum",
      ...getColumnSearchProps("docNum"),
    },
    {
      title: t("date"),
      dataIndex: "docDate",
      key: "docDate",
      text: "center",
      render: (value) => (value ? moment(value).format("DD-MM-YYYY") : "-"),
      // ...getColumnSearchProps("sana"),
    },

    {
      title: t("priceSum"),
      dataIndex: "docTotal",
      key: "docTotal",
      render: (text, record) => {
        const formatSum =
          record.docCur === "UZS"
            ? new Intl.NumberFormat("fr-FR").format(record.docTotalFC)
            : new Intl.NumberFormat("fr-FR").format(text);
        return `${formatSum} ${record.docCur}`;
      },
    },

    {
      title: t("Status"),
      dataIndex: "u_OrderStatus",
      key: "u_OrderStatus",
      ...getColumnSearchProps("u_OrderStatus"),
      render: (text, record) => {
        const status = text
          ? orderStatusLabels.find((status) => {
              return status.value === text;
            })
          : "-";
        // console.log("status=", status);
        return <span>{status?.label}</span>;
      },
    },
    {
      title: t("driver"),
      dataIndex: "driverCardName",
      key: "driverCardName",
    },
    {
      title: t("docStatus"),
      dataIndex: "docStatus",
      key: "docStatus",
      ...getColumnSearchProps("docStatus"),

      render: (text, record) => {
        console.log(record);
        const status =
          text === "C" ? t("closed") : text === "O" ? t("open") : text;
        // console.log("status=", status);
        return (
          <span>
            {text === "C" ? t("closed") : text === "O" ? t("open") : text}{" "}
          </span>
        );
      },
    },
    {
      title: t("remove"),
      dataIndex: "remove",
      key: "remove",
      render: (_, record) => (
        <div className="flex flex-col gap-2">
          <Button
            onClick={(e) => handleButtonClick(e, record)}
            className="min-w-[120px] bg-[#0A4D68] text-white"
            disabled={record.docStatus === "C"}
          >
            {record.docStatus === "C" ? t("closed") : t("remove")}
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div className="flex h-full w-full overflow-y-auto">
      <Menubar />
      <HeaderWithInfinityScroll
        title={"shipments"}
        currentPage={currentPage}
        handlePreviousPage={handlePreviousPage}
        handleNextPage={handleNextPage}
        hasMoreData={hasMoreData}
        columns={columns}
        fdata={fdata}
        loading={loading}
        handleRowClick={handleRowClick}
        onStartDateChange={handleStartDate}
        onEndDateChange={handleEndDate}
        startDate={startDate}
        endDate={endDate}
        formattedDate={moment().format("YYYY-MM-DD")}
        total={total}
        // scrollX={1200}
      />
      <RowDataShipmentModal
        visible={isModalVisible}
        data={selectedRowData}
        onClose={() => setIsModalVisible(false)}
      />

      <EmployeesModal
        visible={isEmployeeModalVisible}
        data={selectedRowData}
        onClose={() => setIsEmployeeModalVisible(false)}
      />
      <RemoveItemModal
        visible={isRemove}
        data={selectedRowData}
        onClose={() => {
          setRemove(false);
        }}
        refetch={() => {
          fetchData(
            currentPage,
            cardName,
            docNum,
            slpName,
            startDate,
            endDate,
            orderStatus,
            docStatus,
            currentPage > 1,
          );
        }}
      />
    </div>
    // <div className="flex h-full w-full overflow-y-auto">
    //   <Menubar />
    //   <div className="h-screen w-full overflow-y-auto">
    //     <Navbar />
    //     <h1 className="font-poppins ml-4 mt-10 text-xl font-bold text-black sm:ml-5 sm:mt-14 sm:text-2xl">
    //       {t("shipments")}
    //     </h1>
    //     <div className="mt-10 w-full border-[1px] border-[#E8E8E8] sm:mt-14"></div>

    //     <div className="ml-5 mt-5 flex gap-5">
    //       <div className="flex flex-col gap-3">
    //         <p>{t("startDate")}</p>
    //         <Input
    //           type="date"
    //           value={startDate}
    //           className="w-[150px]"
    //           onChange={handleStartDate}
    //           max={endDate}
    //         />
    //       </div>
    //       <div className="flex flex-col gap-3">
    //         <p>{t("endDate")}</p>
    //         <Input
    //           type="date"
    //           value={endDate}
    //           className="w-[150px]"
    //           onChange={handleEndDate}
    //           min={startDate}
    //           max={moment().format("YYYY-MM-DD")}
    //         />
    //       </div>
    //     </div>

    //     <div className="mt-10 overflow-x-auto" ref={tableContainerRef}>
    //       <Table
    //         columns={columns}
    //         dataSource={fdata}
    //         pagination={false}
    //         loading={loading || isLoadingMore}
    //         rowKey={(record) => record.docEntry}
    //         onRow={(record) => ({
    //           onClick: () => handleRowClick(record),
    //         })}
    //         scroll={{
    //           y: "calc(100vh - 400px)",
    //           scrollToFirstRowOnChange: false,
    //         }}
    // sticky={{
    //   offsetHeader: 0,
    //   offsetScroll: 0,
    //   getContainer: () => window,
    // }}
    //         summary={() => (
    //           <Table.Summary fixed="bottom">
    //             <Table.Summary.Row>
    //               <Table.Summary.Cell index={0} colSpan={3}>
    //                 <strong>{t("total")}</strong>
    //               </Table.Summary.Cell>
    //               <Table.Summary.Cell index={1} align="right">
    //                 <strong>
    //                   {new Intl.NumberFormat("fr-FR").format(total)} USD
    //                 </strong>
    //               </Table.Summary.Cell>
    //               <Table.Summary.Cell
    //                 index={2}
    //                 colSpan={5}
    //                 align="right"
    //               ></Table.Summary.Cell>
    //             </Table.Summary.Row>
    //           </Table.Summary>
    //         )}
    //       />
    //     </div>
    //   </div>
    //   <RowDataShipmentModal
    //     visible={isModalVisible}
    //     data={selectedRowData}
    //     onClose={() => setIsModalVisible(false)}
    //   />
    //   <RemoveItemModal
    //     visible={isRemove}
    //     data={selectedRowData}
    //     onClose={() => {
    //       setRemove(false);
    //       fetchData(
    //         currentPage,
    //         cardName,
    //         docNum,
    //         slpName,
    //         startDate,
    //         endDate,
    //         orderStatus,
    //         docStatus,
    //         currentPage > 1,
    //       );
    //     }}
    //   />
    // </div>
  );
};

export default Shipments;
